type AdminPermissions =
  | {
      userAdmin?: boolean;
      templateAdmin?: boolean;
      settingAdmin?: boolean;
    }
  | null
  | undefined;

export const getAdminAccessFlags = (permissions: AdminPermissions) => ({
  flow: Boolean(permissions?.templateAdmin),
  helios: Boolean(permissions?.templateAdmin),
  coreUsers: Boolean(permissions?.userAdmin),
  coreModules: Boolean(permissions?.templateAdmin),
  coreRoles: Boolean(permissions?.userAdmin || permissions?.templateAdmin),
  coreSubstitutability: Boolean(permissions?.settingAdmin),
  coreSettings: Boolean(permissions?.settingAdmin),
  coreAssistants: Boolean(permissions?.templateAdmin),
});
